"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RangeInput = RangeInput;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _cx = require("./lib/cx");

var _excluded = ["classNames", "range", "start", "step", "disabled", "onSubmit", "translations"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// if the default value is undefined, React considers the component uncontrolled initially, which we don't want 0 or NaN as the default value
var unsetNumberInputValue = '';

function RangeInput(_ref) {
  var _ref$classNames = _ref.classNames,
      classNames = _ref$classNames === void 0 ? {} : _ref$classNames,
      _ref$range = _ref.range,
      min = _ref$range.min,
      max = _ref$range.max,
      _ref$start = (0, _slicedToArray2.default)(_ref.start, 2),
      minValue = _ref$start[0],
      maxValue = _ref$start[1],
      _ref$step = _ref.step,
      step = _ref$step === void 0 ? 1 : _ref$step,
      disabled = _ref.disabled,
      _onSubmit = _ref.onSubmit,
      translations = _ref.translations,
      props = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  var values = {
    min: minValue !== -Infinity && minValue !== min ? minValue : unsetNumberInputValue,
    max: maxValue !== Infinity && maxValue !== max ? maxValue : unsetNumberInputValue
  };

  var _useState = (0, _react.useState)(values),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      prevValues = _useState2[0],
      setPrevValues = _useState2[1];

  var _useState3 = (0, _react.useState)({
    from: values.min,
    to: values.max
  }),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      _useState4$ = _useState4[0],
      from = _useState4$.from,
      to = _useState4$.to,
      setRange = _useState4[1];

  if (values.min !== prevValues.min || values.max !== prevValues.max) {
    setRange({
      from: values.min,
      to: values.max
    });
    setPrevValues(values);
  }

  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, props, {
    className: (0, _cx.cx)((0, _cx.cx)('ais-RangeInput', classNames.root), disabled && (0, _cx.cx)('ais-RangeInput--noRefinement', classNames.noRefinementRoot), props.className)
  }), /*#__PURE__*/_react.default.createElement("form", {
    className: (0, _cx.cx)('ais-RangeInput-form', classNames.form),
    onSubmit: function onSubmit(event) {
      event.preventDefault();

      _onSubmit([from, to]);
    }
  }, /*#__PURE__*/_react.default.createElement("label", {
    className: (0, _cx.cx)('ais-RangeInput-label', classNames.label)
  }, /*#__PURE__*/_react.default.createElement("input", {
    className: (0, _cx.cx)('ais-RangeInput-input', classNames.input, 'ais-RangeInput-input--min', classNames.inputMin),
    type: "number",
    min: min,
    max: max,
    value: from === null || from === void 0 ? void 0 : from.toString() // Strips leading `0` from a positive number value
    ,
    step: step,
    placeholder: min === null || min === void 0 ? void 0 : min.toString(),
    disabled: disabled,
    onInput: function onInput(_ref2) {
      var currentTarget = _ref2.currentTarget;
      return setRange({
        from: Number(currentTarget.value),
        to: to
      });
    }
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _cx.cx)('ais-RangeInput-separator', classNames.separator)
  }, translations.separatorElementText), /*#__PURE__*/_react.default.createElement("label", {
    className: (0, _cx.cx)('ais-RangeInput-label', classNames.label)
  }, /*#__PURE__*/_react.default.createElement("input", {
    className: (0, _cx.cx)('ais-RangeInput-input', classNames.input, 'ais-RangeInput-input--max', classNames.inputMax),
    type: "number",
    min: min,
    max: max,
    value: to === null || to === void 0 ? void 0 : to.toString() // Strips leading `0` from a positive number value
    ,
    step: step,
    placeholder: max === null || max === void 0 ? void 0 : max.toString(),
    disabled: disabled,
    onInput: function onInput(_ref3) {
      var currentTarget = _ref3.currentTarget;
      return setRange({
        from: from,
        to: Number(currentTarget.value)
      });
    }
  })), /*#__PURE__*/_react.default.createElement("button", {
    className: (0, _cx.cx)('ais-RangeInput-submit', classNames.submit),
    type: "submit"
  }, translations.submitButtonText)));
}